import React, { useState } from "react";
import cx from "classnames";
// @ts-ignore
import BlockContent from "@sanity/block-content-to-react";
import { ClientsListSerializer } from "src/utils/clientsListSerializer";
import { Letter } from "./letters";
import { useMediaQuery, Collapse } from "@material-ui/core/";

import { ReactComponent as Plus } from "src/images/svg/Plus.svg";

import * as styles from "./clients-list.module.css";

const LetterSection = ({ section }: { section: any }) => {
	const isMobile = useMediaQuery("(max-width:767px)");
	const [expanded, setExpanded] = useState(false);

	return (
		<div className={styles.clientsListSection}>
			{isMobile ? (
				<>
					<button
						className={cx(
							"reset",
							styles.sectionButton,
							expanded ? styles.expanded : ""
						)}
						onClick={() => setExpanded(!expanded)}
					>
						<div className={styles.letterContainer}>
							<Letter letter={section.letter} />
						</div>
						<Plus className={styles.plus} />
					</button>
					<Collapse in={expanded}>
						<div className={styles.clientsListSectionBlockContent}>
							<BlockContent
								blocks={section.clients}
								serializers={ClientsListSerializer}
							/>
						</div>
					</Collapse>
				</>
			) : (
				<>
					<Letter letter={section.letter} />
					<BlockContent
						blocks={section.clients}
						serializers={ClientsListSerializer}
					/>
				</>
			)}
		</div>
	);
};

interface ClientListData {
	clients: any[];
	introCopy: any[];
}

export const ClientsList = ({ data }: { data: ClientListData }) => {
	const { clients, introCopy } = data;

	let clientsByLetterObject = clients.reduce((accumulator: {}, item: any) => {
		// get first letter of name of current element

		let letter = "";
		let firstCharacter = item.children[0].text[0].toUpperCase();

		if (/^\d+/.test(firstCharacter)) {
			letter = "ZNumber";
		} else {
			letter = firstCharacter;
		}

		if (!accumulator[letter]) {
			accumulator[letter] = { letter, clients: [item] };
		} else {
			accumulator[letter].clients.push(item);
		}
		return accumulator;
	}, {});

	let clientsByLetter = Object.values(clientsByLetterObject);
	clientsByLetter.sort(function (a: any, b: any) {
		return a.letter.localeCompare(b.letter, undefined, { numeric: false });
	});

	return (
		<div className={styles.clients}>
			<div className={styles.introCopyContainer}>
				<p className={cx("title")}>{introCopy}</p>
				<p className={cx("title c-highlighter")}>Select Clients:</p>
			</div>
			<div className={styles.clientsList}>
				{clientsByLetter &&
					clientsByLetter.map((section: any, index: number) => (
						<LetterSection section={section} key={index} />
					))}
			</div>
		</div>
	);
};
